import React from 'react';
import { colorShades } from "../../component/data/data";
import "../../component/styles/styles.scss";
import { Usepopularcolorcontext } from '../../utils/Hooks/Color-explorer';

export default function Randomshades({ handleColorTab }) {

    const { storeActiveId } = Usepopularcolorcontext();

    return (
        <div className='color-tabs-wrapper'>
            <ul className='color-tabs'>
                {colorShades.map((colorInfo) => {
                    return (
                        <li style={storeActiveId === colorInfo.colorId ? { backgroundColor: colorInfo.colorCode } : { backgroundColor: "#f2f2f3" }} key={colorInfo.colorId} onClick={() => handleColorTab(colorInfo)} className={storeActiveId === colorInfo.colorId ? "tag-active" : "tag-inactive"}>{colorInfo.colorName}</li>
                    )
                })}
            </ul>
        </div>
    )
}
